export enum HttpStatus {
  BAD_REQUEST = 400,
  LOGIN_ERROR = 152
}

export const PAGOEFECTIVO = 1;
export const CUOTEALO = 2;
export const PEN = 'PEN';
export const USD = 'USD';
export const MIN_AMOUNT_PE_PEN = 1;
export const MIN_AMOUNT_PE_USD = 0.5;
